export const jiraProjectContainerType = 'ati:cloud:jira:project';
export const codePlannerSettingsKey = 'code_planner_settings';

export type CodePlannerSettingValueKey = {
	code_planner_enabled: boolean;
};

export type CodePlannerSetting = {
	containerType: string;
	containerId: string;
	key: string;
	value: CodePlannerSettingValue;
};

export type CodePlannerSettingValue = {
	value: CodePlannerSettingValueKey;
	lastUpdatedTime: Date | null;
	containerId: string | null;
};

export type SetCodePlannerSetting = {
	containerId: string;
	value: boolean;
};

export type JiraProject = {
	id: string;
	key: string;
	name: string;
	webUrl: string;
};

// API Types

export type AgentSettingsResponse = {
	success: boolean;
	settings: CodePlannerSetting[];
};
